import { useCallback, useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "sonner"
import { simplePost } from "@/lib/apiUtils"
import { useLocaleStore } from "@/stores/localeStore"
import { useTranslations } from "@/hooks/useTranslations"

/**
 * Start a new pliego: create a chat session and jump straight into it.
 * Single entry point now that the Assistent history page is gone.
 */
export function useStartPliegoSession() {
	const router = useNavigate()
	const t = useTranslations()
	const [isStarting, setIsStarting] = useState(false)

	const startPliego = useCallback(
		async (opts?: { fromTemplate?: boolean }) => {
			if (isStarting) return
			setIsStarting(true)
			try {
				const data = await simplePost<{ locale: string }, { sessionId: string }>(
					"/api/tender-assistant/session",
					{ locale: useLocaleStore.getState().locale },
				)
				router(`/tender-assistant/${data.sessionId}${opts?.fromTemplate ? "?fromTemplate=true" : ""}`)
			} catch {
				toast.error(t("apiErrors.sessionCreateFailed"))
			} finally {
				setIsStarting(false)
			}
		},
		[isStarting, router, t],
	)

	return { startPliego, isStarting }
}
